export default "__VITE_ASSET__OfGS6FDR__"